export default __webpack_public_path__ + "/dist/images/privacypolicy-active.131dc77b319734ad066ee35900495da1.svg";